import type { LucideIcon } from 'lucide-react';
import { cn } from './cn';
import { R } from './tokens';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
  /**
   * icon 容器的视觉变体。
   * - 'card' (默认):外层卡片 + 方形 icon 容器(独立空态页使用)
   * - 'inline':透明外框 + 圆形 icon 容器(嵌入列表 / 面板内,视觉更轻)
   */
  variant?: 'card' | 'inline';
}

export function EmptyState({ icon: Icon, title, description, action, className, variant = 'card' }: EmptyStateProps) {
  const isInline = variant === 'inline';
  return (
    <div
      className={cn(
        'p-8 text-center',
        isInline ? 'bg-transparent' : cn('bg-white border border-slate-200', R.lg),
        className,
      )}
    >
      <div
        className={cn(
          'mx-auto w-14 h-14 flex items-center justify-center mb-4',
          isInline ? 'bg-slate-100 rounded-full' : 'bg-slate-100 rounded-xl',
        )}
      >
        <Icon className="w-7 h-7 text-slate-400" />
      </div>
      <p className="text-sm font-semibold text-slate-700 mb-1">{title}</p>
      {description && (
        <p className="text-sm text-slate-500">{description}</p>
      )}
      {action && (
        <div className="mt-4">{action}</div>
      )}
    </div>
  );
}
